import React from 'react'
import PropTypes from 'prop-types'

function Steps(props) {

    const{page} = props
  return (
    <div className='container'>
        <div className='row'>
            <div className='col-lg-10 mx-auto'>

   


    <div className="StepsGlobal">
        <div className='bar'></div>
        
        <div className={page == 'home' ? 'bullet active' : 'bullet'}>
            <div className="box">
                <span>1</span>
            </div>
            <p className='m-0 text-center'>Parking Details</p>
        </div>
        <div className={page == 'signup' ? 'bullet active' : 'bullet'}>
            <div className="box"><span>2</span> </div>
            <p className='m-0 text-center'>Customer Details</p>
        </div>
        <div className={page == 'pass' ? 'bullet active' : 'bullet'}>
            <div className="box"><span>3</span> </div>
            <p className='m-0 text-center'>Vehicle Details</p>
        </div>
        <div className={page == 'thankyou' ? 'bullet active' : 'bullet'}>
            <div className="box"><span>4</span> </div>
            <p className='m-0 text-center'>Payment Details</p>
        </div>
    </div>
    </div>
    </div>
        </div>

  )
}
Steps.propTypes = {
    page: PropTypes.string,
    paymentStatus: PropTypes.bool
}

Steps.defaulProps = {
	page:undefined,
  paymentStatus: false
}
export default Steps
